import { Injectable } from '@angular/core';
import { IJsonResult } from 'libs/shared/src/models/basic/json';
import { DataProvider } from 'libs/shared/src/providers/basic/data.service';
import { Observable, catchError, map, retry } from 'rxjs';

export interface IVideoDetailPlayResponse {
  downloadUrls: {
    urlMp4: string | null;
    urlWebm: string | null;
    urlOgg: string | null;
    urlFlv: string | null;
    urlYoutube: string | null;
  };
}

@Injectable({
  providedIn: 'root'
})
export class VideoDetailProvider extends DataProvider<any> {
  override endpoint = 'f/components/videodetail/play/';

  /**
   * Submits a review to the server
   * @param reviewData The data of the review to be submitted
   * @returns An Observable of the server response
   */
  play(id: number): Observable<IJsonResult<IVideoDetailPlayResponse>> {
    return this.http
      .get(this.endpointWithUrl + id, this.httpOptions)
      .pipe(
        map((data) => {
          return DataProvider.mapCasesReverse(data);
        })
      )
      .pipe(retry(1), catchError(this.errorService.convert));
  }
}
